import { IMicroConfiguration } from '../types/configuration';
import { RegionBuilder } from '../builders/region_builder';

import { IRegion, IRoute } from'../../../dip/library/di-hnf/di-hnf.js';
import { Process } from'../../../pip/library/pi-interop/pi-interop.js';
import dom from'../../../pip/library/pi-dom/pi-dom.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export type t_region_tag = 'section' | 'hi-dialog' | 'hi-drawer';
interface IViewRenderSharedMemory {
  root: HTMLElement;
}

export class ViewRenderProcess extends Process {
  id = 'view_render';

  dependencies = ['/view_render'];
  processes: {
    view_render: ViewRenderProcess;
  };

  root: HTMLElement;
  configuration: IMicroConfiguration;

  $memory(m: IViewRenderSharedMemory) {
    this.root = m.root;
  }

  initialize(configuration: IMicroConfiguration) {
    this.configuration = configuration;

    dom.write(() => {
      dom.setAttrs(this.root, {
        'x-micro': this.configuration.id,
        'x-shell': 'container'
      });
    });

    return super.initialize(configuration);
  }

  locateRegion(region: IRegion): Element {
    const regionEl = RegionBuilder.isRegionOwned(region)
      ? RegionBuilder.locate(region, this.root)
      : RegionBuilder.build(region);

    this.root.appendChild(regionEl);
    return regionEl;
  }

  reflectStyleRules(state: IRoute) {
    // an old rule from pi-shell was to add classes after the layout_scheme
    // that rule is honored in this logic
    //
    // laytout_scheme="ls my_class_1 my_class_2"
    // we add `my_class_1 my_class_2` to the `class` attribute
    //
    const additionalStyles = f1.is.string(state.layout_scheme)
      ? f1.join(' ', f1.tail(f1.split(' ', state.layout_scheme)))
      : '';

    dom.write(() => {
      dom.setAttr(this.root, 'x-layout-scheme', state.layout_scheme);
      dom.includeAttrList(this.root, 'class', f1.join(' ', [state.style_rules, additionalStyles]));
    });
  }
}
